module.exports = {
  charge_noSelection: '请先选择费用',
  createReceivableBill: '创建应收账单',
  createPayableBill: '创建应付账单',
  finance_inputBusinessNumber: '请输入业务编号',
  finance_query: '查询',
  finance_view: '查看',
  finance_returnQuery: '返回查询',
  finance_batchAudit: '批量审核',
  finance_lockTheBill: '锁单',
  finance_accrue: '计提',
  finance_businessCommission: '业务提成',
  finance_cancelAccrue: '取消计提',
  finance_print: '打印',
  finance_audit: '审核',
  finance_cancelTheAudit: '取消审核',
  finance_chargesAudit: '费用审核',
  finance_cancelTheChargesAudit: '取消费用审核',
  finance_printTheProfit: '利润打印',
  finance_editFinancialDate: '修改财务日期',
  finance_businessAdjustment: '业务调整',
  finance_editChargeFinancialDate: '修改费用财务日期',
  finance_basic: '基本',
  finance_booking: '订舱',
  finance_charges: '费用',
  finance_domesticBill: '国内账单',
  finance_internationalBill: '国外账单',
  finance_collectAndPrepaid: '代收垫付',
  finance_fileHistory: '文件历史',
  finance_exportExcelAll: '导出全部',
  finance_updateBusinessDate: '修改业务日期',
  finance_log: '日志',
  finance_allowChange: '允许改单',
  finance_checkChange: '改单审核',
  finance_batchCheckChange: '批量审核改单',
  finance_revokeChangeCommit: '撤回改单提交',
  charge_receivables: '应收',
  charge_equivalent: '折合',
  charge_inviteToConfirmTheCharges: '邀请确认费用',
  charge_newAdjustment: '增加调整',
  charge_editAdjustment: '修改调整',
  charge_deleteAdjustment: '删除调整',
  charge_writeOffList: '销账明细',
  charge_chargesReject: '费用驳回',
  charge_chargeItem: '费用名称',
  charge_settleAccountsTo: '结算对象',
  charge_invoiceHeader: '开票抬头',
  charge_somesticOrInternational: '国内国外',
  charge_drawABillOrNot: '是否需要开票',
  charge_currency: '币种',
  charge_localCurrency: '本位币币种',
  charge_exchangeRate: '汇率',
  charge_unit: '单位',
  charge_amount: '数量',
  charge_unitPrice: '单价',
  charge_taxIncludedPrice: '含税价',
  charge_taxExcludedPrice: '不含税价',
  charge_taxRate: '税率',
  charge_whtTaxRate: 'WHT税率',
  charge_payables: '应付',
  charge_controlled: '受控',
  charge_cancelControlled: '取消受控',
  charge_taxAmount: '税额',
  charge_whtTaxAmount: 'WHT税额',
  charge_whtTaxLocalAmount: 'WHT税额（本位币）',
  charge_notWhtAmount: '去WHT金额',
  charge_remarks: '备注',
  charge_contactPerson: '联系人',
  charge_relatedBLNo: '关联提单号',
  charge_relatedContainerNo: '关联箱号',
  charge_freightCollectOrPrepaid: '预付到付',
  charge_status: '状态',
  charge_conversionRMB: '折合RMB',
  charge_interest: '费用利息',
  charge_confirmOrNot: '是否确认',
  charge_billNo: '账单号',
  charge_agent_billNo: '代理分成账单号',
  charge_containerNo: '箱号',
  charge_invoiceNo: '发票号',
  charge_invoiceDate: '开票日期',
  charge_agentBillNo: '对方账单号',
  charge_theAmountOfWriteOffs: '核销金额',
  charge_writeOffDate: '销账日期',
  charge_financialDate: '财务日期',
  charge_businessNumber: '业务编号',
  charge_creator: '创建人',
  charge_createTime: '创建时间',
  charge_editor: '更改人',
  charge_editTime: '更改时间',
  charge_paymentApplicationNo: '付款申请号',
  charge_profit: '利润',
  charge_profitAll: '总利润',
  // charge_equivalent: '折合',
  charge_estimateRemarks: '预估备注',
  charge_showRedCharges: '显示红冲费用',
  charge_auditor: '审核人',
  charge_estimate: '预估',
  charge_add: '新增',
  charge_copy: '复制费用',
  charge_delete: '删除',
  charge_edit: '修改',
  charge_chargesAudit: '费用审核',
  charge_cancelTheAudit: '取消审核',
  charge_showCommonCharge: '显示普通费用',
  charge_showSpecialCharge: '显示特殊费用',
  charge_showBusinessSpecialCharge: '显示商务特殊费用',
  charge_businessSpecialFlag: '商务特殊',
  charge_sp1: '运价号',
  charge_sp2: '单击复制运价单号',
  charge_sp3: '根据服务新增',
  charge_sp4: '更新汇率',
  charge_sp5: '抄录小票费用',
  charge_sp6: '抄录应付',
  charge_sp7: '费用方案',
  charge_sp8: '运价表',
  charge_sp9: '取消提交',
  charge_sp10: '提交费用',
  charge_sp11: '费用分摊',
  charge_sp12: '显示分票费用',
  charge_sp13: '服务项目',
  charge_copyCost: '抄录应收',
  charge_copyCharge: '抄录费用',
  charge_payReceiveDate: '收付日期',
  charge_actualAmountNo: '销账流水号',
  charge_newChange: '新增改单费用',
  charge_editChange: '修改改单费用',
  charge_deleteChange: '删除改单费用',
  charge_shared: '分摊',
  charge_showSharedCharges: '显示分摊费用',
  charge_newSpecial: '新增特殊费用',
  charge_newBusinessSpecial: '新增商务特殊费用',
  charge_editSpecial: '编辑特殊费用',
  charge_editBusinessSpecial: '编辑商务特殊费用',
  charge_unitPriceIncludeTax: '单价是否含税',
  charge_locked_status: '是否已锁定',
  domestic_showAllBilling: '显示所有账单',
  domestic_commissionedChargesOnly: '仅显示本委托费用',
  domestic_newReceivables: '新建应收',
  domestic_newPayables: '新建应付',
  domestic_edit: '编辑',
  domestic_delete: '删除',
  domestic_view: '查看',
  domestic_confirm: '确认',
  domestic_cancelConfirm: '取消确认',
  domestic_billNo: '账单号',
  domestic_settleAccountTto: '结算对象',
  domestic_settlementAgent: '结算代理',
  domestic_invoiceHeader: '开票抬头',
  domestic_currency: '币种',
  domestic_chargeAmount: '金额',
  domestic_totalCurrency: '分币种合计',
  domestic_revenueAndExpenditureType: '收支类型',
  domestic_confirmationStatus: '确认状态',
  domestic_invoicingStatus: '开票状态',
  domestic_writeOffStatus: '核销状态',
  domestic_revenueOrExpenditure: '收支',
  domestic_chargeItem: '费用名称',
  domestic_unit: '单位',
  domestic_amount: '数量',
  domestic_unitPrice: '单价',
  domestic_taxIncludedPrice: '含税价',
  domestic_taxExcludedPrice: '不含税价',
  domestic_taxRate: '税率',
  domestic_taxAmount: '税额',
  domestic_remarks: '备注',
  domestic_billingGroupNo: '对账单号',
  domestic_billingBranchId: '账单所属分公司',
  international_showAllBilling: '显示所有账单',
  international_commissionedChargesOnly: '仅显示本委托费用',
  international_add: '新增',
  international_edit: '编辑',
  international_delete: '删除',
  international_audit: '审核',
  international_invalid: '作废',
  international_agentProfitShareBillNo: '代理分成账单',
  international_printAllAgentProfitShareBillNo: '打印所有代理分成账单',
  international_editAgentBillNo: '编辑对方账单号',
  international_billNo: '账单号',
  international_agentBillNo: '对方账单号',
  international_revenueAndExpenditureType: '收支类型',
  international_settleAccountTo: '结算对象',
  international_settlementAgent: '结算代理',
  international_currency: '币种',
  international_chargeAmount: '金额',
  international_status: '状态',
  international_billType: '账单类型',
  international_invoicingStatus: '开票状态',
  international_writeOffStatus: '核销状态',
  international_billDtae: '账单日期',
  international_creator: '创建人',
  international_businessNumber: '业务编号',
  international_billingGroupNo: '对账单号',
  international_revenueOrExpenditure: '收支',
  international_chargeItem: '费用名称',
  international_taxIncludedPrice: '含税价',
  international_taxExcludedPrice: '不含税价',
  international_taxRate: '税率',
  international_taxAmount: '税额',
  international_unit: '单位',
  international_amount: '数量',
  international_unitPrice: '单价',
  international_remarks: '备注',
  adChargeInfo_prepaid: '垫付',
  adChargeInfo_print: '打印',
  adChargeInfo_newAdjustment: '增加调整',
  adChargeInfo_editAdjustment: '修改调整',
  adChargeInfo_deleteAdjustment: '删除调整',
  adChargeInfo_addBoth: '同时新增',
  adChargeInfo_add: '新增',
  adChargeInfo_delete: '删除',
  adChargeInfo_chargeItem: '费用名称',
  adChargeInfo_settleAccountsTo: '结算对象',
  adChargeInfo_domesticOrInternational: '国内国外',
  adChargeInfo_currency: '币种',
  adChargeInfo_unit: '单位',
  adChargeInfo_quantity: '数量',
  adChargeInfo_unitPrice: '单价',
  adChargeInfo_exchangeRate: '汇率',
  adChargeInfo_amount: '金额',
  adChargeInfo_remarks: '备注',
  adChargeInfo_billNo: '账单号',
  adChargeInfo_taxNo: '税金号',
  arChargeInfo_theAmountOfWriteOffs: '核销金额',
  apChargeInfo_theAmountOfWriteOffs: '核销金额',
  adChargeInfo_collect: '代收',
  adChargeInfo_submitCharge: '提交费用',
  adChargeInfo_cancelSubmit: '取消提交',
  adChargeInfo_status: '状态',
  adChargeInfo_paymentApplicationNo: '付款申请号',
  international_forceDelete: '强制删除',
  return: '返回',
  Confirm: '确定',
  Cancel: '取消',
  accrualDate: '计提日期',
  adjustmentItem: '调整项',
  adjustmentValue: '调整值',
  charge_ProvisionedDate: '计提日期',
  charge_specialUpdate: '特殊费用调整',
  charge_settleDepartmentPrefix: '结算部门',
  charge_paymentApplicationDateCreated: '请款单创建日期',
  charge_SapStatus: 'SAP状态',
  finance_ChargeCommit: '改单提交',
  separateAllocation: '分单分摊情况',
  allocationType: '分摊类型',
  costSharingValue: '分摊费用值',
  modifyField: '修改字段',
  operationContent: '操作内容',
  statusAfterOperation: '操作后状态',
  routeLeader: '路线负责人',
  selectAdjustmentItem: '请选择调整项',
  businessInfoAdjustedSuccess: '业务信息调整成功',
  apportionedTax: '分摊税额',
  charge_asyncCharges: '费用同步',
  charge_asyncChargeRecords: '费用同步记录',
  lockBusinessSuccess: '锁单操作成功',
  AccountVerifyBusinessSuccess: '审核操作成功',
  AccrualSucceeded: '计提成功',
  charge_asyncChargesToImportJob: '同步至进口业务',
  charge_syncChargesConfirmStatus: '同步费用状态',
  charge_cancelSyncChargesConfirmStatus: '取消同步费用状态',
  charge_syncChargesToSI: '转进口费用同步',
  charge_cancelSyncChargesToSI: '取消转进口费用同步',
  charge_syncPayable: '费用同步',
  charge_isSync: '是否同步',
  charge_paymentAmount: '收付金额',
  expenseSharingReceipt: '费用分摊小票',
  correspondingAllocationBusiness: '对应分摊业务',
  allocateRelatedBusinesses: '分摊关联业务',
  BusinessSyncModifyBusinessDate: '出口业务将同步修改业务日期',
  ImportBusinessSyncModifyBusinessDate: '进口业务将同步修改业务日期',
  ExportBusinessItemCannotEmpty: '出口业务此项目不允许为空',
  ImportBusinessItemCannotEmpty: '进口业务此项目不允许为空',
  LandTransportationBusinessItemCannotEmpty: '陆运业务此项目不允许为空',
  synchronizationFeesToBeProcessed: '条同步费用待处理',
  markAsRead: '标为已读',
  fail: '不通过',
  applyRecallCharge: '申请撤回费用',
  recallState: '撤回状态',
  recallCause: '撤回原因',
  youCanOnlyOperateOnConfirmedCharges: '仅能对已确认的费用进行操作',
  thereAreCostsThatHaveBeenWithdrawn: '存在已经被撤回的费用，请勿重复提交',
  theFeeHasEnteredTheSettlementProcess: '费用已进入结算环节，不可撤回。需从对账确认、账单、发票、付款申请、销账记录等单据解除关联。',
  PleaseSeparateTheFeesForConfirmationAndWithdrawal: '首次待确认和申请撤回的费用请分开操作',
  receivablePayable: '应收/应付',
  currency: '币别',
  sender: '发送方',
  receiver: '接收方',
  syncProgress: '同步进度',
  processingStatus: '处理状态',
  sendingTime: '发送时间',
  auditOperationTime: '审核操作时间',
  pending: '待处理',
  alreadyRead: '已读',
  notRead: '未读',
  businessHasBeenSubmitted: '业务已提交，无法通过并添加费用。如有必要，请联系业务主管取消提交。',
  selectBeConfirmedChargeByUs: '请选择待我方确认的费用',
  selectRejectedChargeByOppositeParty: '请选择对方已拒绝的费用',
  pleaseSaveTheCurrentPageFirst: '请先保存当前页面',
  commissionAmount: '提成金额',
  charge_writeOffDate_ar: '核销日期',
  charge_writeOffDate_ap: '核销日期',
  GenerateVoucher: '是否已生成凭证',
  CurrencyAccountsReceivable: '分币种应收：',
  CurrencyAccountsPayable: '分币种应付：',
  today: '当天',
  thisMonthEnd: '本月底',
  previousMonthEnd: '上月底',
  IssueMonthOfYear: '{0}年第{1}期',
  QMonthYear: '{0}年第{1}季度',
  XYear: '{0}年',
  SongtiSerif: '宋体,serif',
  TrialBalance: '科目余额表',
  BalanceSheetWithContacts: '往来余额表',
  StatementOfAccountWithContacts: '往来核对账',
  SubsidiaryLedger: '明细账',
  GeneralLedger: '总账',
  Receive: '收',
  Pay: '付',
  Transfer: '转',
  ForeignCurrencyRevaluation: '期末调汇',
  RetainedEarnings: '结转本期损益',
  Billion: '亿',
  Thousand: '千',
  Hundred: '百',
  Ten: '十',
  TenThousand: '万',
  Yuan: '元',
  Dime: '角',
  Cent: '分',
  FailedObtainCurrentFiscalPeriod: '获取当前财务期间失败!',
  Total: '合计',
  Quantity: '数量：',
  UnitPrice: '单价：',
  ForeignCurrency: '原币：',
  UnbalancedDebitAndCreditEntry: '录入借贷不平！',
  ThisVoucherPleaseEditInModule: '此凭证是业务凭证\n请至“生成凭证”模块编辑',
  ForeignCurrencyCannotBeEmpty: '原币不能为空',
  ClientItemCannotBeEmpty: '辅助项客户不能为空',
  SupplierItemCannotBeEmpty: '辅助项供应商不能为空',
  StaffItemCannotBeEmpty: '辅助项职员不能为空',
  ProjectItemCannotBeEmpty: '辅助项项目不能为空',
  DepartmentItemCannotBeEmpty: '辅助项部门不能为空',
  Client: '客户',
  Supplier: '供应商',
  Department: '部门',
  Staff: '职员',
  Project: '项目',
  Currency: '币种：',
  Amount: '金额：',
  ExchangeRate: '汇率：',
  All: '全部',
  Yes: '是',
  No: '否',
  Year: '年',
  Period: '期',
  PleaseSelectVoucherRange: '请选择凭证区间',
  Assets: '资产',
  Liabilities: '负债',
  Equity: '权益',
  Cost: '成本',
  ProfitAndLoss: '损益',
  ClientSupplier: '客户/供应商',
  BalanceInRMB: '余额人民币',
  UnmatchedClientOrSupplier: '未匹配的客户或者供应商',
  AddAssetAccount: '新增资产类科目',
  Add: '新增',
  Edit: '编辑',
  Delete: '删除',
  AddCashFlowItem: '新增现金流量项目',
  ImportSucceeded: '导入成功',
  DesignSubaccounts: '设计子科目',
  NeedToExport: '需要导出',
  NoExportNeeded: '不需要导出',
  SeparatorSettings: '分隔符设置',
  ExportSeparator: '导出分隔符',
  Separator: '分隔符:',
  PleaseFinancialYearForReport: '请填写需要初始化报表的财务年度，',
  RepeatingDataLossPleaseCaution: '重复初始化将导致已维护数据丢失，请慎用。',
  InitializationPleaseCheckAccountSettings: '初始化成功，请查看科目设置。',
  InitializationPleaseCheckTheReport: '初始化成功，请查看报表。',
  DetailedEntryRulesConfiguration: '分录摘要规则配置',
  FeeWillBeDeleted: '注：即将删除{0}条费用',
  AccountNotFound: '账套不存在',
  Quarter: '季度',
  AccountingVoucher: '会计凭证',
  StatusUnknown: '状态未知',
  N0Year0Period: '{0}年第{1}期',
  SyncCloudSucceededXFailedX: '同步云星空成功{0}条，失败{1}条',
  SyncExceptionReason: '同步异常原因',
  SyncCloudStarrySky: '同步云星空',
  SyncFeeCannotSyncAgain: '已同步费用无法再次同步！',
  DisplayTransactions: '显示往来业务',
  EnterBusinessNumberBeforeQuery: '请输入业务编号后进行查询',
  SelectNewEncodingType: '选择新增编码类型',
  SelectMatchingPartnerFieldType: '选择匹配合作伙伴字段类型',
  NewEncodingType: '新增编码类型：',
  CustomerCode: '客户编码',
  SupplierCode: '供应商编码',
  AtLeastOneCustomerAndSupplierCode: '客户编码、供应商编码至少勾选一个',
  MatchPartnerFieldTypes: '匹配合作伙伴字段类型：',
  PartnersCode: '合作伙伴_代码',
  PartnersNumber: '合作伙伴_编号',
  PartnersChineseName: '合作伙伴_中文名',
  ImportCustomerAndProviderCode: '确定导入[{0}]作为此账套合作伙伴的客户编码及供应商编码？',
  ImportCustomerCode: '确定导入[{0}]作为此账套合作伙伴的客户编码？',
  ImportProviderCode: '确定导入[{0}]作为此账套合作伙伴的供应商编码？',
  ImportCodePenddingTip: '客商编码导入中...<br>离开当前页面不会影响数据导入，导入完成后会通知您。',
  ModifyExpirationDate: '修改到期日',
  ModifyChargeExpirationDate: '修改费用到期日',
  RemoveCountFee: '请移除已计算的费用',
  ChargeHqCurrency: 'HQ当地币种',
  ChargeHqRate: 'HQ当地币种汇率',
  CostType: '成本类型',
  HideForeignCurrencyProfitLoss: '不显示外币损益结转',
  GpExplain: 'GP说明',
  Peer: '委托单位是否同行',
  ProfitRate: '利润率',
  ArRowsAndApRows: '应收行数/应付行数',
  ArIncludeAp: '应收包含应付',
  Allocation: 'Allocation',
  LclTicketsCanNotAudit: '拼箱小票不能单独审核，请审核主票。',
  SelectedDataJobSubmitNotAllowAudit: '选择的数据中有业务提交人和当前审核人相同，不允许审核，请检查！',
  SelectedDataJobSubmitNotAllowCancelAudit: '选择的数据中有提交人和当前审核人相同，不允许取消审核，请检查！',
  SelectedDataChargeByNotAllowCancelAudit: '选择的数据中有改单提交人和当前审核人相同，不允许审核，请检查！',
  JobSubmitNotAllowAudit: '业务提交人和当前审核人相同，不允许审核！',
  JobSubmitNotAllowCancelAudit: '业务提交人和当前审核人相同，不允许取消审核！',
  JobSubmitNotAllowCancelChangeOrder: '业务提交人和当前审核人相同，不能允许改单！',
  ChargeSubmitNotAllowAudit: '费用提交人和当前审核人相同，不允许审核！',
  ChargeSubmitNotAllowCancelAudit: '费用提交人和当前审核人相同，不允许取消费用审核！',
  ChargeSubmitNotAllowCancelChangeOrder: '费用提交人和当前审核人相同，不允许改单审核！',
  AdditionalCostRemarks: '追加费用备注',
  AdditionalCostRemarksContent: '追加费用备注内容',
  JobSubmitNotAllowCancelAdjustCosts: '业务提交人和当前审核人相同，不能允许调整费用！'
}
